﻿import { loadUserData, saveUserData } from "./userStore.js";

export function loadWatchlists(user) {
  const d = loadUserData("watchlists", user, null);
  return d && Array.isArray(d.lists) ? d : { lists: [], activeId: null };
}

export function saveWatchlists(user, data) {
  saveUserData("watchlists", user, data);
}
